<template>
	<div class="row m-0 h-100">
		<div class="form-section col-md-4 col-lg-3 p-0 m-0 h-100">
			<div class="select-user-container d-flex flex-column">
				<label>{{ $t("res_Label_SelectUser") }}</label>
				<StructureUserSelector :showInternalUsers="true" :showExternalUsers="false"
						:showInternalStructures="false" :showExternalStructures="false"
						:excludeSelf="false" :isMultiple="false" :addressBook_header="$t('res_Label_SelectUser')"
						:selectedStructureUser="previewUser" @structureUserSelectChanged="structureUserSelectChanged">
					</StructureUserSelector>
			</div>
		</div>
		<div class="viewer-wrapper col-md-8 col-lg-9 h-100 p-0 m-0 h-100">
			<div class="d-flex flex-column h-100">
				<div class="p-0 scrollable-container flex-1 center-document">
					<div style="min-height: 400px; width: 450px;" class="viewer_template">
            			<vue-pdf-embed :source="templateSource" />
                    </div>
				</div>
				<div class="dialog-footer sticky-footer top-shadow p-3 d-flex align-items-center justify-content-end gap-3 position-relative">
					<v-btn color="light-blue" @click="closeDialog()">{{ $t("res_ButtonText_Cancel") }}</v-btn>
					<v-btn class="primary" @click="previewSignatureForSelectedUser">{{ $t("res_ButtonText_Preview") }}</v-btn>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    import MultiSelect  from 'vue-multiselect'
	import constants from '@/assets/js/constants.js'
	import axios from 'axios'
    import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed.js'
	import * as utils from '@/assets/js/common.js'
	import StructureUserSelector from '@/components/StructureUserSelector.vue'

	export default {
		name: 'PreviewSignature',
        components: { MultiSelect, VuePdfEmbed,StructureUserSelector },
        props: {
            documentId: { type: Number, default: 0 },
        },
		data() 
        {
            return {
                loading: false,
				usersList: [],
				previewUser: null,
                templateSource: '',
            };
        },
		methods:
		{
			// asyncFindPreviewUser (query) 
			// {
			// 	if (query == '') return;

			// 	axios.get(constants.baseApiUrl + 'StructureUser/search?showUsers=true&showInternalStructures=false&showExternalStructures=false&search=' + query)
			// 		.then(res => this.usersList = res.data)
			// 		.catch(err => console.log(err));
			// },
            // CapitalizeFirstLetter(str)
            // {
			// 	return utils.CapitalizeFirstLetter(str)
            // },
            // GetMultiSelectSubHeaderDisplay(options)
            // {
            //     return utils.GetMultiSelectSubHeaderDisplay(options)
            // },
			previewSignatureForSelectedUser()
			{
				if (this.previewUser == null)
				{
					window.showAlert('res_Msgs_SelectUserForSignature', 'warning')
					return
				}

				var url = constants.baseApiUrl + 'Document/PreviewSignature?documentId=' + this.documentId;
				url = url + '&userId=' + this.previewUser.id.split('-')[0] + '&structureId=' + this.previewUser.id.split('-')[1];

				window.showLoading()
				axios.post(url, null)
					.then(res => 
					{
                        this.templateSource = 'data:application/pdf;base64,' + res.data
					})
					.catch(err => console.log(err))
					.finally(() => window.hideLoading())
			},
			closeDialog()
			{
				this.$emit('closeDialog')
			},
			structureUserSelectChanged(userSelected){
				this.previewUser = userSelected
			}
		}
	}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>